import { create } from 'zustand';
import type { User } from '@supabase/supabase-js';
import { supabase } from '@/lib/supabase';

interface AuthState {
  user: User | null;
  /** Пока вход не определился — экран-заставка держится. */
  isLoading: boolean;
  setUser: (user: User | null, isLoading?: boolean) => void;
  /** Пароль принят, но у человека подключён код входа — ждём шесть цифр (src/lib/mfa.ts). */
  mfaPending: boolean;
  setMfaPending: (pending: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  setUser: (user, isLoading = false) => set({ user, isLoading }),
  mfaPending: false,
  setMfaPending: (mfaPending) => set({ mfaPending }),
}));

export async function login(email: string, password: string): Promise<{ error: Error | null }> {
  const { error } = await supabase.auth.signInWithPassword({ email, password });
  return { error: error ?? null };
}

export async function logout(): Promise<void> {
  // Ключ push снимаем, пока пропуск Chatwoot ещё жив (при выключенных push — мгновенно).
  try {
    const { forgetPushDevice } = await import('@/lib/push');
    await forgetPushDevice();
  } catch { /* выход важнее */ }
  await supabase.auth.signOut();
}
